module.exports = __webpack_public_path__ + "img/admin.cfea32cd.svg";